module.exports = __webpack_public_path__ + "img/midas_titulo.80674ae2.jpg";